export default __webpack_public_path__ + "static/media/fondo_register.00b28d23.jpg";